<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="listStorage"
      single-expand
      :search="search"
      :loading="loading"
      item-key="callid"
      class="alignTableOnBackground ml-5 mr-5 elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon class="px-1" @click="deletedStorage(item)">
              <v-icon small v-on="on">mdi-delete-off</v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Vue from "vue";

export default {
  props: {
    search: String,
  },
  data: () => ({
    // allStorage : [], //Se guardan todos los storage del cliente.
    headers: [
      { text: "ID", value: "id", sortable: "false" },
      { text: "Nombre del Bucket", value: "nameBucket", sortable: "true" },
      { text: "Proveedor", value: "providerName", sortable: "true" },
      { text: "", value: "actions", sortable: "false" },
    ],
  }),
  methods: {
    deletedStorage(item) {
      this.$store.dispatch("storage/deleteStorage", {
        storageId: item.id,
      });
    },
  },
  computed: {
    ...mapGetters("storage", { listStorage: "storageTable" }), // Traemos los valores
  },
  created() {
    this.$store.dispatch("storage/getAllStorage");
  },
};
</script>
